import React from 'react'
import PropTypes from 'prop-types'
import { Box, styled, Typography } from '@mui/material'

const StyledBox = styled(Box)((props) => ({
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    color: props.color,
    backgroundColor: props.backgroundColor,
    height: props.height,
    borderRadius: `${props.borderRadius}px ${props.borderRadius}px 0 0`,
    borderBottom: '1px solid #efeff1',
}))

const GenericCardHeader = ({
    color,
    backgroundColor,
    height,
    icon,
    heading,
    borderRadius,
}) => {
    return (
        <StyledBox
            color={color}
            backgroundColor={backgroundColor}
            height={height}
            borderRadius={borderRadius}
        >
            {icon}
            <Typography variant="h2">{heading}</Typography>
        </StyledBox>
    )
}

GenericCardHeader.propTypes = {
    icon: PropTypes.element,
    borderRadius: PropTypes.number,
}

GenericCardHeader.defaultProps = {
    borderRadius: 5,
}

export default GenericCardHeader
